import React from "react";
import SlideShowComponent from "./SlideShowComponent";
import { getURLFromField } from "../utils";
import useElements from "../hooks/useElements";

const SlideShow = ({ value, ...props }) => {
  const wuiltContext = useElements();
  const imageLoader = wuiltContext?.base?.imageLoader;
  const slides =
    value?.map((slide) => ({
      id: slide?.id,
      src: imageLoader({ src: getURLFromField(slide.image) }),
    })) || [];

  return (
    <>
      {/* @ts-ignore */}
      <SlideShowComponent {...props} images={slides} />
    </>
  );
};

export default SlideShow;
